import { helpers } from '@vuelidate/validators';
import timestring from 'timestring';

import { MinMrt, MaxMrt } from '@/constants';

function validTime(message: string) {
  return helpers.withMessage(message, (val: string) => {
    try {
      const mrtInS = timestring(val);
      if (mrtInS > MaxMrt || mrtInS < MinMrt) {return false;}
    } catch (_error) { return false;}
    return true;
  });
}

export default validTime;
